import { render } from "./DashboardBar2.vue?vue&type=template&id=df1adf60&scoped=true"
import script from "./DashboardBar2.vue?vue&type=script&lang=js"
export * from "./DashboardBar2.vue?vue&type=script&lang=js"

import "./DashboardBar2.vue?vue&type=style&index=0&id=df1adf60&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df1adf60"]])

export default __exports__